export const usePaymentError = () => {
  const { t } = useI18n();

  const PAYMENT_ERROR_CODE_MAP: Record<number, string> = {
    20001: 'alert_card_payment_failed',
    20002: 'alert_card_payment_failed',
    20003: 'alert_invalid_request',
    20004: 'alert_card_payment_failed',

    21001: 'alert_card_number_invalid',
    21002: 'alert_card_info_invalid',
    21003: 'alert_card_invalid',
    21004: 'alert_card_declined',

    22001: 'alert_payment_limit_or_balance',
    22002: 'alert_card_not_register',
    22003: 'alert_card_payment_failed',
    22004: 'alert_card_payment_failed',

    23001: 'alert_payment_not_completed',
    23002: 'alert_payment_not_completed',
    23003: 'alert_payment_not_completed',
    23004: 'alert_card_maintenance',
    23005: 'alert_payment_not_completed',
    23006: 'alert_payment_not_completed',

    25001: 'alert_card_maintenance_in_progress',
    25002: 'alert_bank_maintenance_time',
    25003: 'alert_payment_unknown_error',
    25004: 'alert_payment_unknown_error',
  } as const;

  const FALLBACK_ERROR_KEY = 'alert_payment_unknown_error';

  const handlePaymentError = (code: number) => {
    const errorMessage = PAYMENT_ERROR_CODE_MAP[code] ?? FALLBACK_ERROR_KEY;
    return t(errorMessage);
  };

  return {
    handlePaymentError,
  };
};
